import { R } from '@core/utils/r';
import { Breadcrumbs } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { memo, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';

const useStyles = makeStyles({
  root: {
    fontSize: 'inherit !important',
    fontFamily: 'inherit !important',
    lineHeight: 'inheret !important',
    letterSpacing: 'inherent !important',
    'font-weight': 'inherit !important',
  },
});

export interface BreadcrumbProps {
  showCapitalBreadcrumbs?: boolean;
  breadcrumbTitle?: string;
}

export const Breadcrumb = memo((props: BreadcrumbProps) => {
  const { showCapitalBreadcrumbs, breadcrumbTitle } = props;
  const rawbreadcrumbs = useBreadcrumbs();

  const breadcrumbs = useMemo(() => {
    const last = R.last(rawbreadcrumbs);
    if (last) {
      const lastVal = R.last(R.split(last.key.toString(), '/'));

      if (R.toNumber(lastVal) > 0) {
        return R.initial(rawbreadcrumbs);
      }
    }
    return rawbreadcrumbs;
  }, [rawbreadcrumbs]);

  const capitalizeBreadcrumb = useCallback((breadcrumb: any) => {
    const breadcrumbTitle = breadcrumb.props.children
      .split('-')
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join('-');

    return breadcrumbTitle;
  }, []);

  const links = useMemo(() => R.initial(breadcrumbs), [breadcrumbs]);
  const last = useMemo(() => R.last(breadcrumbs), [breadcrumbs]);

  const classes = useStyles();
  if (breadcrumbs.length < 2) return null;
  return (
    <Breadcrumbs
      separator={<i className="bx bx-right-arrow-alt"></i>}
      aria-label="breadcrumb"
      className="breadcrumb-inheret"
      classes={{
        root: classes.root,
        ol: 'breadcrumb m-0',
        li: 'breadcrumb-item',
      }}
    >
      {links.map(({ match, breadcrumb }) => (
        <Link key={match.url} color="inherit" to={match.url}>
          {breadcrumb}
        </Link>
      ))}
      {!!last && <div>{breadcrumbTitle ? breadcrumbTitle : showCapitalBreadcrumbs ? capitalizeBreadcrumb(last.breadcrumb) : last.breadcrumb}</div>}
    </Breadcrumbs>
  );
});
